import Drilldown from 'components/drilldown/Layout'
import lossesBetaStore from 'modules/report/stores/losses'

import { formatters } from 'components/hierarchical-report/utils'

export default class LossesDrilldown extends Drilldown {
  store = lossesBetaStore
  collection = 'Sessions'
  report = 'losses'

  metrics = {
    formConverted: { label: 'Form Converted', field: 'converted', value: true },
    converted: { label: 'Converted', field: 'conversiontype', value: 'converted' },
    scrub: { label: 'Scrub', field: 'conversiontype', value: ['scrub', 'scrub_bucket'] },
    fraudConversion: { label: 'Converted as Fraud', field: 'conversiontype', value: 'fraud' },
    fraudCheckTrue: { label: 'Is fraud', field: 'fraud_verification', value: 1 },
    fraudCheckFalse: { label: 'Is Not fraud', field: 'fraud_verification', value: 0 },
    fraudNotCheck: { label: 'Fraud not verified', field: 'fraud_verification', value: -1 },
    awaitingFraudCheck: { label: 'Awaiting Fraud Verification', field: 'fraudscore', value: 'awaiting' },
    completed: { label: 'Completed', field: 'registration_completed', value: true },
    duplicated: { label: 'Duplicated', field: 'duplicated', value: true },
    duplicatedData: { label: 'Duplicated Data', field: 'duplicatedData', value: true },
    duplicatedClick: { label: 'Duplicated Click', field: 'duplicatedClick', value: true },
    tcpaconsent: { label: 'TCPA Consent', field: 'tcpaConsent', value: true },
    total: { label: 'Session' },
  }

  fields = {
    default: ['userSessionId', 'conversionType', 'converted', 'duplicated', 'completed', 'consent', 'registrationStep', 'skipRegistration', 'tcpaConsent'],
    options: [
      { group: 'Traffic', value: 'publisherId', label: 'Publisher Id' },
      { group: 'Traffic', value: 'allocationId', label: 'Allocation Id' },
      { group: 'Traffic', value: 'conversionType', label: 'Conversion Type' },
      { group: 'Traffic', value: 'payoutType', label: 'Payout Type' },
      { group: 'Traffic', value: 'sid1', label: 'SubID 1' },
      { group: 'Traffic', value: 'sid2', label: 'SubID 2' },
      { group: 'Traffic', value: 'sid3', label: 'SubID 3' },
      { group: 'Traffic', value: 'campaignId', label: 'Campaign Id' },
      { group: 'Traffic', value: 'externalId', label: 'External Id' },
      { group: 'Traffic', value: 'cost', label: 'Cost' },
      { group: 'Traffic', value: 'isAnomalous', label: 'Is Anomalous' },

      { group: 'Session', value: 'userSessionId', label: 'User Session Id' },
      { group: 'Session', value: 'duplicated', label: 'Duplicated' },
      { group: 'Session', value: 'duplicatedData', label: 'Duplicated Data' },
      { group: 'Session', value: 'duplicatedClick', label: 'Duplicated Click' },
      { group: 'Session', value: 'sessionCookie', label: 'Cookie' },
      { group: 'Session', value: 'optout', label: 'Optout' },
      { group: "Session", value: "sessionCreatedAt" , label: "Created At" },
      { group: "Session", value: "sessionUpdatedAt" , label: "Updated At" },
      { group: "Session", value: "sessionFormId" , label: "Form Id" },
      { group: "Session", value: "sessionOfferId" , label: "Offer Id" },
      { group: "Session", value: "sessionPathId" , label: "Path Id" },
      { group: "Session", value: "sessionSlotPosition" , label: "Slot Position" },
      { group: "Session", value: "sessionOriginalUrl" , label: "Url" },
      { group: "Session", value: "sessionTrustedFormCert" , label: "Trusted Form" },
      { group: "Session", value: "sessionLeadidCert" , label: "Lead Id" },
      { group: "Session", value: "sessionAddressVerification" , label: "Address Verification" },
      { group: "Session", value: "sessionHook" , label: "Hook" },
      { group: "Session", value: "sessionIpCity" , label: "Ip City" },
      { group: "Session", value: "sessionIpState" , label: "Ip State" },
      { group: "Session", value: "sessionIpZip" , label: "Ip Zip" },

      { group: 'Client', value: 'browser', label: 'Browser' },
      { group: 'Client', value: 'browserAgent', label: 'Browser Agent' },
      { group: 'Client', value: 'ipAddress', label: 'Ip Address' },
      { group: 'Client', value: 'device', label: 'Device' },
      { group: 'Client', value: 'os', label: 'OS' },
      { group: 'Client', value: 'referrer', label: 'Referrer' },


      { group: 'Timestamp', value: 'createdAt', label: 'Created At' },
      { group: 'Timestamp', value: 'updatedAt', label: 'Updated At' },

      { group: 'Form', value: 'formId', label: 'Id' },
      { group: 'Form', value: 'formTotalSteps', label: 'Total Steps' },
      { group: 'Form', value: 'formConversionStep', label: 'Conversion Step' },

      { group: 'Verification', value: 'emailVerification', label: 'Email Verification' },
      { group: 'Verification', value: 'fraudVerification', label: 'Fraud Verification' },
      { group: 'Verification', value: 'botVerification', label: 'Bot Verification' },
      { group: 'Verification', value: 'fraudScore', label: 'Fraud Score' },
      { group: 'Verification', value: 'phoneVerification', label: 'Phone Verification' },
      { group: 'Verification', value: 'postalVerification', label: 'Postal Verification' },

      { group: 'Organization', value: 'organizationId', label: 'Organization Id' },
      { group: 'Organization', value: 'siteId', label: 'Site Id' },
      { group: 'Organization', value: 'pathId', label: 'Path Id' },

      { group: 'Post', value: 'postId', label: 'Post Id' },
      { group: 'Post', value: 'postTargetId', label: 'Post Target Id' },
      { group: 'Post', value: 'postVersionId', label: 'Post Version' },

      { group: 'Registration', value: 'converted', label: 'Converted' },
      { group: 'Registration', value: 'completed', label: 'Completed' },
      { group: 'Registration', value: 'tcpaConsent', label: 'TCPA Consent' },
      { group: 'Registration', value: 'consent', label: 'Consent' },
      { group: 'Registration', value: 'recordingConsent', label: 'Recording Consent' },
      { group: 'Registration', value: 'registrationStep', label: 'Step' },
      { group: 'Registration', value: 'registrationTotalStep', label: 'Total Step' },
      { group: 'Registration', value: 'skipRegistration', label: 'Skip Registration' },

      { group: 'Revenue', value: 'revenueOrigins', label: 'Origins' },
      { group: 'Revenue', value: 'revenueTransactionIds', label: 'Transactions Ids' },
      { group: 'Revenue', value: 'revenueIntegrationIds', label: 'Integrations Ids' },
      { group: 'Revenue', value: 'revenue', label: 'Total' },

      { group: 'User', value: 'userAge', label: 'Age' },
      { group: 'User', value: 'userEmailDomain', label: 'Email Domain' },
      { group: 'User', value: 'userId', label: 'Id' },

      { group: "User", value: "userFirstName", label: "First Name" },
      { group: "User", value: "userLastName", label: "Last Name" },
      { group: "User", value: "userEmail", label: "E-mail" },
      { group: "User", value: "userAddress1", label: "Address 1" },
      { group: "User", value: "userAddress2", label: "Address 2" },
      { group: "User", value: "userCity", label: "City" },
      { group: "User", value: "userState", label: "State" },
      { group: "User", value: "userZip", label: "Zip" },
      { group: "User", value: "userCountry", label: "Country" },
      { group: "User", value: "userPhone", label: "Phone" },
      { group: "User", value: "userDob", label: "Date of Birth" },
      { group: "User", value: "userGender", label: "Gender" }
    ],
    fieldsFormatters: {
      userId: cell => formatters.openNewTab("/reports/audit", { key: "id", value: cell }),
      userEmail: cell => formatters.openNewTab("/reports/audit", { key: "email", value: cell }),
      userPhone: cell => formatters.openNewTab("/reports/audit", { key: "phone", value: cell })
    }
  }
}
